<template>
    <div class="form-sub-section attachments-section" v-bind:class="{ 'view-mode': !canEditAttachments }">
        <div class="d-flex justify-content-between align-items-center">
            <span >
                <h3 v-if="!replyAttachments" class="main-text-large">{{ $t("res_CardHeaders_Attachments") }}</h3>
                <h3 v-else class="main-text-large">{{ $t("res_Label_OtherAttachments") }}</h3>
            </span>
            <div>
                <v-btn class="dgs-new-button-icon" style="min-width: 19px !important;" icon
                @click="DownloadAllAttachments()" v-tooltip="$t('res_label_DownloadAll')">
                <v-icon class="primary-hover">mdi-download</v-icon>
            </v-btn>
            <v-btn @click="collapseAttachments = !collapseAttachments" class="dgs-new-button"
                style="width: 40px; min-width: unset !important">
                <span v-if="collapseAttachments" class="arrow-down"></span>
                <span v-else class="arrow-up"></span>
            </v-btn>
            </div>
            
        </div>
        <v-progress-linear class="m-1" v-if="uploadProgress > 0 && uploadProgress < 100" :value="uploadProgress"
            height="8" rounded><span class="progress-text">{{ uploadProgress }}%</span></v-progress-linear>
        <v-divider v-if="!collapseAttachments"></v-divider>
        <div :style="{ display: collapseAttachments ? 'none' : 'block' }">
            <div>
                <v-list>
                    <v-list-item v-for="(item, i) in (fileAttachments || [])" :key="i">
                        <div class="d-flex justify-content-between align-items-center w-100" v-if="!isLoading">
                            <div class="d-flex align-items-center overflow-hidden " style="gap:12px"
                                @click="displayAttachment(item)">
                                <v-icon class="attachment_icon p-0">
                                    {{ getIconForExtension(item.extension) }}
                                </v-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>
                                        <span class="action-label-new overflow-hidden text-nowrap overflow-ellipsis"
                                            :v-tooltip="item.name || ''">
                                            {{ item.name }}
                                        </span>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        <span class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                            {{ $t("res_MenuItems_TaskProjectCreatedDate") + " : " + (item.createdDate ? item.createdDate.substring(0, 10) : '') }}
                                        </span>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        <v-chip dark label small v-if="i == 0">
                                            {{ $t("res_Label_OriginalMail") }}
                                        </v-chip>
                                        <v-chip dark label small v-else>
                                            {{ $t("res_Label_Attachment") }}
                                        </v-chip>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        <v-divider :thickness="10" v-if="i == 0 && fileAttachments.length > 1">

                                        </v-divider>

                                    </v-list-item-subtitle>

                                </v-list-item-content>
                            </div>
                            <div class="d-flex align-items-center flex-column" style="gap: 8px;">
                                <span class="item-size dark-text text-end">
                                    {{ utils.formatBytes(item.fileSize, 2) }}
                                </span>
                                <v-btn icon small
                                    @click="downloadAttachment(item.id, item.name + '.' + item.extension)"
                                    v-tooltip="$t('res_Label_Download')">
                                    <v-icon class="primary-hover" color="primary">mdi-download</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-list-item>
                </v-list>
                <v-divider class="view-all-divider"
                    ></v-divider>
                <div class="view-all-wrapper d-flex justify-content-center align-content-center"
                    >
                    <button class="view-all-btn d-flex align-items-center" @click="viewAllAttachments()"
                        v-if="numberOfAttachmentsToDisplay != 1000">
                        {{ $t("res_ButtonText_ViewAll") }} <v-icon class="light">mdi-chevron-down</v-icon>
                    </button>
                    <button class="view-all-btn d-flex align-items-center" @click="viewAllAttachments()"
                        v-if="numberOfAttachmentsToDisplay == 1000">
                        {{ $t("res_ButtonText_ShowLess") }} <v-icon class="light">mdi-chevron-up</v-icon>
                    </button>
                </div>
                <v-dialog v-model="deleteAttachmentDialog" content-class="small-dialog" width="500" height="400">
                    <v-card>
                        <v-card-title>
                            {{ $t("res_Msgs_DeleteConfirmation") }}
                        </v-card-title>
                        <div class="card-body">
                            <label>{{ $t("res_Msgs_DeleteAttachmentConfirmation") }}</label>
                        </div>
                        <v-card-actions class="gap-2 sticky-actions">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="this.deleteAttachment">{{ $t("res_ButtonText_Continue")
                            }}</v-btn>
                            <v-btn color="light-blue" @click="deleteAttachmentDialog = false">{{
                                $t("res_ButtonText_Cancel")
                                }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="renameAttachmentDialog" content-class="small-dialog" width="500" height="350">
                    <v-card>
                        <v-card-title>
                            {{ $t("res_GridHeaders_RenameAttachment") }}
                        </v-card-title>
                        <div class="card-body">
                            <label>{{ $t("res_Label_NewName") }}</label>
                            <v-text-field v-model="attachmentUpdatedName" solo></v-text-field>
                        </div>
                        <v-card-actions class="gap-2 sticky-actions">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :disabled="isRenameButtonDisabled" @click="renameAttachment">{{
                                $t("res_ButtonText_Save") }}</v-btn>
                            <v-btn color="light-blue" @click="renameAttachmentDialog = false">{{
                                $t("res_ButtonText_Cancel")
                                }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="attachmentConfigureDialog" content-class="fullscreen-dialog dialog bg-white"
                    width="100%" fullscreen>
                    <div class="dialog-header">
                        <v-toolbar class="bg-white">
                            <div class="d-flex align-items-center">
                                <div class="custom-icon-wrapper">
                                    <v-icon @click="attachmentConfigureDialog = false">custom-icon
                                        left-arrow-icon</v-icon>
                                </div>
                                <h1 class="mb-0">{{ $t("res_Label_ConfigureSignatures") }}</h1>
                            </div>
                            <v-spacer></v-spacer>
                            <div class="d-flex" style="gap:12px; margin-right:24px">
                            </div>
                            <v-btn class="close-btn light-btn" icon dark @click="attachmentConfigureDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </div>
                    <div class="dialog-body h-100 d-flex">
                        <iframe id="configureSignatureFrm" :src="configureSignatureSrc" title=""
                            style="width: 100%; height: 100%;"></iframe>
                    </div>
                </v-dialog>

                <input type="file" style="display:none"
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.gif,.bmp,.tif,.tiff,.msg,.rar,.zip,.7z"
                    @change="onMultiFileChanged" ref="multiUploader" multiple />

                <input type="file" style="display:none"
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.gif,.bmp,.tif,.tiff,.msg,.rar,.zip,.7z"
                    @change="onFileChanged" ref="uploader" multiple />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import SignatureConfigure from '@/components/SignatureConfigure.vue'

export default {
    name: 'Attachment',
    components: { Multiselect, SignatureConfigure },
    props: {
        documentId: { type: Number, default: 0 },
        delegationId: { type: Number, default: 0 },
        viewMode: { type: String, default: 'readonly' },
        disabledUpload: { type: Boolean, default: false },
        canAddAttachments: { type: Boolean, default: false },
        canEditAttachments: { type: Boolean, default: false },
        isSentTab: { type: Boolean, default: false },
        replyAttachments: { type: Boolean, default: false },
    },
    data() {
        return {
            collapseAttachments: false,
            isLoading: false,
            isOriginal: false,
            deleteAttachmentDialog: false,
            renameAttachmentDialog: false,
            fileAttachments: [],
            fileAttachmentsFullList: [],
            userId: 0,
            document: {
                firstAttachment: true,
                attachmentName: '',
                originalAttachmentName: '',
                attachmentId: 0,
                storageAttachmentId: 0,
            },
            attachmentUpdatedName: '',
            isRenameButtonDisabled: true,
            binaryAttachment: '',
            selectedFiles: [],
            selectedFile: {},
            constants: constants,
            attachSingleFile: false,
            attachMultipleFile: false,
            attachmentConfigureDialog: false,
            maxNumberOfSigners: 0,
            attachementHeading: '',
            attachmentId: 0,
            ConfigureSignature: window.translate("res_Label_ConfigureSignatures"),//"Configure Signature",
            configureSignatureSrc: '',
            icons: [
                { icon: 'mdi-file-pdf-box', ext: 'pdf' },
                { icon: 'mdi-file-document', ext: 'docx' },
                { icon: 'mdi-file-document', ext: 'doc' },
                { icon: 'mdi-file-image', ext: 'jpg' },
                { icon: 'mdi-file-image', ext: 'jpeg' },
                { icon: 'mdi-image', ext: 'png' },
            ],
            utils: utils,
            defaultNumberOfAttachmentsToDisplay: 3,
            numberOfAttachmentsToDisplay: 3,
            auditTrailData: {
                oldData: [],
                newData: [],
            },
            uploadProgress: 0,
            imageExtensions: ["jpg", "jpeg", "png", "gif", "bmp"],
            compressedExtensions: ["zip", "rar", "7z", "tar", "gz", "bz2", "xz", "z", "tar.gz", "tgz", "tar.bz2", "tbz2", "tar.xz", "txz"],
            emailFileExtensions: ["eml", "msg", "mbox", "pst", "ost", "oft", "nsf", "olm", "ics", "vcf"]
        };
    },
    mounted() {
        // var user = JSON.parse(sessionStorage.getItem("user"));
        // this.userId = user.profile.Id
 
        this.userId = 0;
        this.isLoading = true;
        this.getAttachments();
        this.uploadProgress = 0;
    },
    watch:
    {

        documentId() {
            this.getAttachments()
        },
        attachmentUpdatedName: function (newVal, oldVal) {
            if (this.attachmentUpdatedName.trim() == '' || this.attachmentUpdatedName == this.document.originalAttachmentName)
                this.isRenameButtonDisabled = true
            else
                this.isRenameButtonDisabled = false
        }
    },
    methods:
    {
        getIconForExtension(extension) {
            if (extension === 'pdf') {
                return "mdi-file-pdf-box";
            } else if (['doc', 'docx'].includes(extension)) {
                return "mdi-file-word";
            } else if (this.compressedExtensions.includes(extension)) {
                return "mdi-extension-zip-box";
            } else if (this.emailFileExtensions.includes(extension)) {
                return "mdi-extension-email";
            } else if (this.imageExtensions.includes(extension)) {
                return "mdi-extension-image";
            } else {
                return "mdi-file";
            }
        },
        disabledUploadbtn() {
            if (this.isLoading || (this.uploadProgress > 0)) {
                return true
            }
            return false
        },
        signDocumentWithDocusign(attachmentId) {

            window.showLoading();
            let baseUrl = constants.baseApiUrl;
            axios.post(baseUrl + 'Document/PrepareAttachmentForDocuSign?storageAttachmentId=' + attachmentId + "&documentId=" + this.documentId)
                .then(res => {
                    var windowObjectReference = window.open(res.data.item2, "Sign With Docusign", '_blank');
                    window.hideLoading();
                    console.log('data', res)
                })
                .catch(error => console.log(error))
        },
        canDelete(i, item) {
            if (!this.canEditAttachments) {
                return false
            }

            if (item.isEditable && i != 0)
                return true
            else
                return false
        },
        openOptionPane(attachmentId, storageAttachmentId, attachmentName, extension, optionId, attachmentKey) {
            this.document.attachmentId = attachmentId
            this.document.storageAttachmentId = storageAttachmentId
            this.document.attachmentName = attachmentName
            this.document.originalAttachmentName = attachmentName
            if (optionId == 1) {
                this.attachmentUpdatedName = attachmentName
                this.renameAttachmentDialog = true
            }
            else if (optionId == 2) {
                // if(this.documentSubject !== null && this.documentSubject != '' )
                //         attachmentName = this.documentSubject;
                var nameParts = attachmentName.split('.');
                if (nameParts.length == 1) {
                    this.downloadAttachment(attachmentId, attachmentName + '.' + extension);
                } else {
                    this.downloadAttachment(attachmentId, attachmentName);
                }

            }
            else if (optionId == 3) {
                this.replaceAttachment(attachmentKey)
            }
            else if (optionId == 4) {
                this.attachmentId = attachmentId
                this.attachementHeading = attachmentName
                this.maxNumberOfSigners = 0
                var signatureCount = parseInt(window.documentView.template_signatureCount)

                var url = "?signaturesCount=" + signatureCount
                    + "&attachmentName=" + attachmentName + '&lang=' + this.$i18n.locale;

                window.setConfigureSignatureData(this.documentId, this.attachmentId);
                this.configureSignatureSrc =
                    'resources/configureSignature/ConfigureSignature.html' + url + '&r=' + new Date().getTime()
                this.attachmentConfigureDialog = true
            }
            else {
                this.deleteAttachmentDialog = true
            }
        },
        replaceAttachment(key) {
            if (key == 0)
                this.isOriginal = true
            else
                this.isOriginal = false

            window.addEventListener('focus', () => { }, { once: true });
            this.attachSingleFile = true;
            this.$refs.uploader.click();
        },
        renameAttachment() {
            if (this.attachmentUpdatedName == '') {
                window.showAlert('res_Msgs_EnterAttachmentName', 'warning')
                return
            }

            this.renameAttachmentDialog = false

            window.showLoading()
            axios.get(constants.baseApiUrl + 'Attachment/UpdateAttachment?attachmentId=' + this.document.attachmentId + '&storageAttachmentId=' + this.document.storageAttachmentId + '&newName=' + this.attachmentUpdatedName)
                .then(response => {
                    if (response.data != null && response.data != undefined && response.data.success) {
                        this.getAttachments();
                        this.attachmentUpdatedName = ''
                        this.renameAttachmentDialog = false;
                        window.showAlert('res_Msgs_AttachmentRenamed', 'success')
                    }
                    else
                        console.log(response.data.message)
                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading())
        },
        deleteAttachment() {
            this.deleteAttachmentDialog = false
            this.fileAttachments = []
            this.fileAttachmentsFullList = []

            // window.showLoading()
            this.isLoading = true;
            axios.get(constants.baseApiUrl + 'Attachment/DeleteFile?attachmentId=' + this.document.attachmentId + "&documentId=" + this.documentId)
                .then(response => {
                    if (response.data != null) {
                        this.getAttachments()
                        this.$refs.uploader.value = '';
                        this.$refs.multiUploader.value = '';
                        if (response.data.success) {
                            window.showAlert('res_Msgs_AttachmentDeleted', 'success')
                        } else {
                            window.showAlert(response.data.message, 'warning')
                        }
                    }
                })
                .catch(error => { window.showAlert("res_Msgs_AttachmentCouldNotDelete", "warning") })
                .finally(() => { this.isLoading = false; this.uploadProgress = 0; })
        },
        downloadAttachment(attachmentId, fileName) {
            utils.DownloadFile(constants.baseApiUrl + 'Attachment/Download?attachmentId=' + attachmentId, fileName)
        },
        // DownloadMultipleZipped() {
        //     const attachmentIds = this.fileAttachmentsFullList.map(file => file.id);
        //     utils.DownloadMultipleZipped(constants.baseApiUrl + 'Attachment/DownloadMultipleZipped', attachmentIds)
        // },
        getAttachments() {
            if (this.documentId == 0)
                return

            this.fileAttachments = []
            this.fileAttachmentsFullList = []
            this.numberOfAttachmentsToDisplay = this.defaultNumberOfAttachmentsToDisplay

            const endPointName = this.isSentTab && this.replyAttachments ? 'GetReplyDocumentAttachments' : 'GetAttachmentsByDocumentId';
            // window.showLoading()
            axios.get(constants.baseApiUrl + 'Document/' + endPointName + '?documentId=' + this.documentId + '&delegationId=' + this.delegationId, { headers: constants.headers })
                .then(res => {
                    if (res.data != null && res.data.success) {
                        var response = res.data.data;
                        if (response.totalCount > 0) {
                            this.firstAttachment = false
                            this.fileAttachments = []
                            this.fileAttachmentsFullList = []
                            response.attachments.forEach(element => {
                                if (this.fileAttachments.length < this.defaultNumberOfAttachmentsToDisplay)
                                    this.fileAttachments.push(element)
                                this.fileAttachmentsFullList.push(element)
                            });
                        }
                    }
                })
                .catch(error => console.log(error))
                .finally(() => { this.isLoading = false; this.uploadProgress = 0; })
        },
        uploadAttachment() {
            if (this.firstAttachment) {
                window.addEventListener('focus', () => { }, { once: true });
                this.attachSingleFile = true;
                this.$refs.uploader.click();
            }
            else {
                window.addEventListener('focus', () => { }, { once: true });
                this.attachMultipleFile = true;
                this.$refs.multiUploader.click();
            }
            this.$refs.uploader.value = '';
            this.$refs.multiUploader.value = '';
        },
        onFileChanged(e) {
            if (this.$refs.uploader.files[0].size <= 0 || this.$refs.uploader.files[0].size > parseInt(constants.maxAttachmentSizeInByte)) {
                window.showAlert(window.translate("res_Msgs_FileSizeValidation1") + constants.maxAttachmentSizeInMb + window.translate("res_Msgs_FileSizeValidation2"), "warning");
            }
            else {

                this.uploadChuckFile(this.$refs.uploader.files[0], true);
            }
        },
        uploadFile(uploadChunkTempId) {
            this.attachMultipleFile = false;
            this.attachSingleFile = false;

            if (this.document.storageAttachmentId > 0) {
                let singleAttachment = new FormData();

                singleAttachment.append('Id', this.document.attachmentId)
                singleAttachment.append('DocumentId', this.documentId)
                // singleAttachment.append('IsOriginalMail', this.isOriginal)
                singleAttachment.append('uploadChunkTempId', uploadChunkTempId)

                const headers2 = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer ' + localStorage.getItem('user')
                };

                // window.showLoading()
                this.isLoading = true;
                axios.post(constants.baseApiUrl + 'Attachment/Replace', singleAttachment, { headers: headers2 })
                    .then(response => {
                        if (response != null || response != undefined) {
                            this.getAttachments()
                        }
                    })
                    .catch(error => this.handleError(error))
                    .finally(() => { this.isLoading = false; this.uploadProgress = 0; })
            }
            else {
                this.uploadMultipleFiles(uploadChunkTempId);
            }
        },
        onMultiFileChanged(e) {
            Array.from(this.$refs.multiUploader.files).forEach(file => {
                if (file.size <= 0 || file.size > parseInt(constants.maxAttachmentSizeInByte)) {
                    window.showAlert(window.translate("res_Msgs_FileSizeValidation1") + constants.maxAttachmentSizeInMb + window.translate("res_Msgs_FileSizeValidation2"), "warning");
                }
                else {
                    this.uploadChuckFile(file, false);
                }
            });
        },
        async uploadChuckFile(file, isSigleFile) {
            this.uploadProgress = 1;
            await parent.window.uploadChunkService.uploadChunkService(file, {
                onProgress: (progress) => {
                    this.uploadProgress = progress;
                },
                onComplete: (uploadChunkTempId) => {
                    this.uploadProgress = 100;
                    if (isSigleFile) {
                        this.uploadFile(uploadChunkTempId);
                    } else {
                        this.uploadMultipleFiles(uploadChunkTempId);
                    }
                },
                onError: (uploadChunkTempId, errorMessage) => {
                    this.uploadProgress = 0;
                    if (uploadChunkTempId != '') {
                        parent.window.uploadChunkService.deleteChunkUploading(uploadChunkTempId);
                    }
                    window.showAlert(errorMessage, 'success');
                },
                onAbort: (uploadChunkTempId) => {
                    this.disabledAction = false;
                    this.uploadProgress = 0;

                    if (uploadChunkTempId != '') {
                        parent.window.uploadChunkService.deleteChunkUploading(uploadChunkTempId);
                    }
                    window.showAlert('res_label_uploadAborted', 'warning');
                },
            });

        },
        uploadMultipleFiles(uploadChunkTempId) {
            this.attachMultipleFile = false;
            this.attachSingleFile = false;
            let formData = new FormData();
            formData.append('documentId', this.documentId)
            formData.append('uploadChunkTempId', uploadChunkTempId)

            const headers2 = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + localStorage.getItem('user')
            };

            // window.showLoading();
            this.isLoading = true;
            axios.post(constants.baseApiUrl + 'Attachment/Upload', formData, { headers: headers2 })
                .then(response => {
                    if ((response != null || response != undefined) && response.data != null && response.data.success) {
                        this.getAttachments();
                        window.showAlert('res_Msgs_AttachmentUploaded', 'success');
                    } else {
                        window.showAlert(response.data.message, 'error');
                    }
                })
                .catch(error => this.handleError(error))
                .finally(() => { this.isLoading = false; this.uploadProgress = 0; });
        },
        displayAttachment(item) {
            this.$emit('setViewerUrl', item.id);
        },
        viewAllAttachments() {
            if (this.numberOfAttachmentsToDisplay == 1000) {
                this.numberOfAttachmentsToDisplay = this.defaultNumberOfAttachmentsToDisplay
                this.fileAttachments = this.fileAttachmentsFullList.slice(0, this.defaultNumberOfAttachmentsToDisplay)
            }
            else {
                this.numberOfAttachmentsToDisplay = 1000
                this.fileAttachments = this.fileAttachmentsFullList
            }
        },
        DownloadAllAttachments() {
            this.fileAttachmentsFullList.forEach(element => {
                this.downloadAttachment(element.id, element.name + '.' + element.extension);
            });
        }
    },
}

import 'floating-vue/dist/style.css'
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.attachment_icon {
    font-size: 30px;
    padding-left: 5px;
    padding-right: 5px;
    color: cornflowerblue;
}
.custom-icon-wrapper,
.vertical-dots-icon {
  opacity: 1 !important;
  visibility: visible !important;
}
.v-list-item:hover {
  background: transparent !important;
}
.v-list-item::before {
  background-color: transparent !important;
}
.v-btn:hover {
  background: transparent !important;
}
.v-btn:hover .v-icon {
  color: #2196F3 !important;
}
.v-btn::before {
  background-color: transparent !important;
}
</style>